import { fabric } from 'fabric';
import { getLineLength } from '../polygon/polygon.helper';

export class ResizeableLine extends fabric.Line {
  get length(): number {
    return getLineLength({ x: this.x1, y: this.y1 }, { x: this.x2, y: this.y2 });
  }

  private _thicknessOffset: number;

  constructor(points?: number[], objObjects?: fabric.ILineOptions) {
    super(points, {
      hasBorders: false,
      cornerSize: 24,
      padding: 20,
      ...objObjects,
    });

    this._thicknessOffset = objObjects.strokeWidth / 2;

    this._controlsVisibility = {
      tl: false,
      bl: false,
      tr: false,
      br: false,
      ml: false,
      mr: false,
      mt: false,
      mb: false,
      mtr: false,
    };

    this._initResizeControls();

    // recalc real coordinates, as moving fabric objects only changes left/top properties
    this.on('modified', (event: any) => {
      const line = event.transform.target as ResizeableLine;
      const linePoints = line.calcLinePoints();
      const center = line.getCenterPoint();

      line.set({
        x1: center.x + linePoints.x1,
        x2: center.x + linePoints.x2,
        y1: center.y + linePoints.y1,
        y2: center.y + linePoints.y2,
      });
    });
  }

  private _resizeHandler(eventData: MouseEvent, transformData: fabric.Transform, x: number, y: number) {
    transformData.action = 'resize';
    const line = transformData.target as ResizeableLine;

    if (transformData.corner === 'startPoint') {
      line.set({
        x1: x,
        y1: y,
      });
    } else {
      line.set({
        x2: x,
        y2: y,
      });
    }

    line.controls.endPoint.x = line.x2 > line.x1 ? 0.5 : -0.5;
    line.controls.endPoint.y = line.y2 > line.y1 ? 0.5 : -0.5;
    line.controls.endPoint.offsetX = line.x2 > line.x1 ? -line.padding : line.padding;
    line.controls.endPoint.offsetY =
      line.y2 > line.y1 ? -line.padding - line._thicknessOffset : line.padding + line._thicknessOffset;

    line.controls.startPoint.x = -line.controls.endPoint.x;
    line.controls.startPoint.y = -line.controls.endPoint.y;
    line.controls.startPoint.offsetX = -line.controls.endPoint.offsetX;
    line.controls.startPoint.offsetY = -line.controls.endPoint.offsetY;

    return true;
  }

  private _initResizeControls() {
    this.controls.startPoint = new fabric.Control({
      x: -0.5,
      y: 0.5,
      offsetX: this.padding,
      offsetY: -this.padding - this._thicknessOffset,
      actionHandler: this._resizeHandler,
      cursorStyle: 'pointer',
    });

    this.controls.endPoint = new fabric.Control({
      x: 0.5,
      y: -0.5,
      offsetX: -this.padding,
      offsetY: this.padding + this._thicknessOffset,
      actionHandler: this._resizeHandler,
      cursorStyle: 'pointer',
    });
  }
}
